export function startUpdate({ commit }) {
  commit('START_UPDATE')
}

export function updatePrefInState({ commit }, data) {
  commit('UPDATE_PREF_IN_STATE', data)
}
